document.addEventListener("DOMContentLoaded", () => {
  // const FREEBIE_IDS = [42351497019469, 42359368941645, 42359367598157];


    const FREEBIE_IDS = [42351497019469];


  // ⬅️ supports multiple main variants
  const MAIN_VARIANT_IDS = [42345176825933, 42439465599053];

  // 🔥 NEW – one-time freebie ID
  const ONE_TIME_FREEBIE = 42351497019469;

  let skeletonCheckInterval;
  let lastFreebieCount = 0;
  let lastHasMain = false;
  let lastMainAddedAt = 0;
  let forcedVisible = false;
  const STATUS_BANNER_SOURCE = "freebie-shampoo";

  function getStatusBannerState() {
    if (!window.__freebieStatusBannerState) {
      window.__freebieStatusBannerState = {
        activeSources: new Set(),
        hideTimer: null,
        isVisible: false,
        sourceShownAt: {},
      };
    }
    if (!window.__freebieStatusBannerState.sourceShownAt) {
      window.__freebieStatusBannerState.sourceShownAt = {};
    }
    return window.__freebieStatusBannerState;
  }

  function getSkeletonContainer() {
    return document.querySelector("#freebie-skeleton-container");
  }

  function getStatusBanner() {
    let banner = document.querySelector("#freebie-status-banner");
    if (!banner) {
      banner = document.createElement("div");
      banner.id = "freebie-status-banner";
      banner.innerHTML = "🎁 Adding your free gifts…";
      document.querySelector(".drawer__cart-items-wrapper")?.prepend(banner);
    }
    const state = getStatusBannerState();
    banner.classList.toggle("visible", state.isVisible);
    return banner;
  }

  function setStatusBannerVisible(banner, isVisible) {
    const state = getStatusBannerState();
    const hideCurrentBanners = () => {
      state.isVisible = false;
      document
        .querySelectorAll("#freebie-status-banner")
        .forEach((el) => el.classList.remove("visible"));
    };
    const scheduleHide = (delay) => {
      state.hideTimer = setTimeout(() => {
        const now = Date.now();
        const hasFreshSource = Array.from(state.activeSources).some(
          (source) => now - (state.sourceShownAt[source] || 0) < 1800,
        );
        if (hasFreshSource) {
          scheduleHide(300);
        } else {
          state.activeSources.clear();
          state.sourceShownAt = {};
          hideCurrentBanners();
          state.hideTimer = null;
        }
      }, delay);
    };

    if (isVisible) {
      clearTimeout(state.hideTimer);
      state.hideTimer = null;
      state.activeSources.add(STATUS_BANNER_SOURCE);
      state.sourceShownAt[STATUS_BANNER_SOURCE] = Date.now();
      state.isVisible = true;
      banner.classList.add("visible");
      return;
    }

    state.activeSources.delete(STATUS_BANNER_SOURCE);
    delete state.sourceShownAt[STATUS_BANNER_SOURCE];
    clearTimeout(state.hideTimer);
    state.hideTimer = null;
    if (!state.isVisible) {
      banner.classList.remove("visible");
      return;
    }

    scheduleHide(300);
  }

  function restoreStatusBannerVisibility() {
    const state = getStatusBannerState();
    if (!state.isVisible) return;
    getStatusBanner().classList.add("visible");
  }

  function showSkeleton(container, banner) {
    container.classList.add("active");
    container.querySelectorAll(".freebie-skeleton").forEach(el => el.classList.add("active"));
    setStatusBannerVisible(banner, true);
  }
  function hideSkeleton(container, banner) {
    container.classList.remove("active");
    container.querySelectorAll(".freebie-skeleton").forEach(el => el.classList.remove("active"));
    setStatusBannerVisible(banner, false);
  }

  function isAutoShipTabActive() {
    const autoShip = document.querySelector('#auto-ship');
    return autoShip && autoShip.classList.contains('active');
  }

  function hasSubscriptionItem(cart) {
    return cart.items.some(item =>
      MAIN_VARIANT_IDS.includes(item.variant_id) &&
      item.selling_plan_allocation
    );
  }

  async function checkCartForFreebies() {
    const skeletonContainer = getSkeletonContainer();
    if (!skeletonContainer) return;

    const banner = getStatusBanner();

    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();

      const hasMain = cart.items.some(i => MAIN_VARIANT_IDS.includes(i.variant_id));

     const freebiesInCart = cart.items.filter(i =>
  FREEBIE_IDS.includes(i.variant_id)
);

      const freebieCount = freebiesInCart.length;
      const now = Date.now();
      const hasSubscription = hasSubscriptionItem(cart);

      // 🔥 NEW – expected freebies depends on subscription
      const expectedFreebies = hasSubscription ? FREEBIE_IDS.length : 1;

      // 🔥 NEW – dynamic completion logic
      const allFreebiesLoaded = freebieCount >= expectedFreebies;

      if (hasMain && !lastHasMain) {
        lastMainAddedAt = now;
        forcedVisible = true;
        showSkeleton(skeletonContainer, banner);

        setTimeout(() => {
          forcedVisible = false;
        }, 2000);
      }

      if (!hasMain) {
        hideSkeleton(skeletonContainer, banner);
        clearInterval(skeletonCheckInterval);
        lastFreebieCount = 0;
        lastHasMain = false;
        return;
      }

if ((hasMain && !allFreebiesLoaded && (now - lastMainAddedAt < 2000)) || forcedVisible) {
        if (isAutoShipTabActive() || hasSubscription) {
          showSkeleton(skeletonContainer, banner);
        } else {
          showSkeleton(skeletonContainer, banner); // keep for 1-time gift as well
        }
      }

      // 🔥 UPDATED – stop loader when correct number of freebies is added
      if (allFreebiesLoaded && !forcedVisible) {

        // one-time purchase should stop when 1 freebie is added
        if (!hasSubscription && freebieCount === 1) {
          hideSkeleton(skeletonContainer, banner);
          clearInterval(skeletonCheckInterval);
          lastFreebieCount = freebieCount;
          lastHasMain = hasMain;
          return;
        }

        // subscription should stop when all 3 freebies added
        if (hasSubscription && freebieCount === FREEBIE_IDS.length) {
          hideSkeleton(skeletonContainer, banner);
          clearInterval(skeletonCheckInterval);
          lastFreebieCount = freebieCount;
          lastHasMain = hasMain;
          return;
        }
      }

      lastFreebieCount = freebieCount;
      lastHasMain = hasMain;

    } catch (err) {
      console.error("⚠️ Freebie skeleton check failed:", err);
    }
  }

  function startSkeletonWatcher() {
    clearInterval(skeletonCheckInterval);
    restoreStatusBannerVisibility();
    setTimeout(checkCartForFreebies, 300);
    skeletonCheckInterval = setInterval(checkCartForFreebies, 800);
  }

  document.addEventListener("cart:updated", startSkeletonWatcher);
  document.addEventListener("cart:refresh", startSkeletonWatcher);
  document.addEventListener("shopify:section:load", startSkeletonWatcher);

  const observer = new MutationObserver(() => {
    if (document.querySelector("#CartDrawer")) startSkeletonWatcher();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.querySelectorAll('.offer-tab span').forEach(tab => {
    tab.addEventListener('click', () => {
      const skeletonContainer = getSkeletonContainer();
      const banner = getStatusBanner();
      if (!isAutoShipTabActive()) {
        hideSkeleton(skeletonContainer, banner);
      } else {
        startSkeletonWatcher();
      }
    });
  });

  startSkeletonWatcher();
});
